<template>
    <modal
    @close="close"
    :titleVisible="false">
      <template #body>
       <div class="modal-video">
        <iframe width="560" height="315" :src="iframe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
       </div>
      </template>
    </modal>
  </template>
  
  <script>
  import modal from "~/components/UI/Modal.vue"
  export default {
    components: {
      modal
    },
    props: {
      code: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        iframe: ``,
        url: 'https://rutube.ru/play/embed/',
      }
    },
    methods: {
      close() {
        this.$emit('close')
        this.iframe = ""
      },
      videoUrl() {
        this.iframe = this.url + this.code
      }
    },
    watch: {
      code(val) {
        this.iframe = `<iframe width="560" height="315" src="${this.url}${this.code}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
      }
    },
    created() {
      this.iframe = `<iframe width="560" height="315" src="${this.url}${this.code}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
    },
    mounted() {
      this.videoUrl()
    }

  }
  </script>